import { render, staticRenderFns } from "./ScreenAnchorObjectProperties.vue?vue&type=template&id=153ab5e2&scoped=true&"
import script from "./ScreenAnchorObjectProperties.vue?vue&type=script&lang=js&"
export * from "./ScreenAnchorObjectProperties.vue?vue&type=script&lang=js&"
import style0 from "./ScreenAnchorObjectProperties.vue?vue&type=style&index=0&id=153ab5e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153ab5e2",
  null
  
)

export default component.exports